import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/site-data";

export default function UrgenceBanner() {
  return (
    <div data-testid="urgence-banner" className="relative border-y border-terra/20 bg-[#170F0B]">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-4">
        <div className="flex items-center gap-3">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-terra opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-terra" />
          </span>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra">
            Urgence fuite · Intervention sous 2 h en Gironde
          </p>
        </div>
        <a
          href={COMPANY.phoneHref}
          data-testid="urgence-call-button"
          className="flex items-center gap-2 rounded-full border border-terra/40 px-5 py-2 text-sm font-semibold text-terra transition-colors duration-300 hover:bg-terra hover:text-white"
        >
          <Phone className="h-4 w-4" />
          {COMPANY.phone}
        </a>
      </div>
    </div>
  );
}
